import { SelectItemOverlay } from 'component/layout_quiz/select_item_overlay';
import { useEffect, useRef } from 'react';
import { useStyles } from './styles';

export interface IBodyItemProps {
    imageUrl: string;
    label: String;
    isSelect: Boolean;
    handleClick: any;
    isDisplayContent: boolean;
}

export default function BodyItem({ imageUrl, label, isSelect, handleClick, isDisplayContent }: IBodyItemProps) {
    const classes = useStyles();
    let itemRef: any = useRef();

    useEffect(() => {
        if (itemRef && isSelect) {
            (itemRef as any).scrollIntoView({ behavior: 'auto', block: 'center', inline: 'center' });
        }
    }, [itemRef, isSelect]);

    return (
        <div
            className={classes.wrapperItem}
            ref={(ref) => {
                itemRef = ref;
            }}
            style={{
                padding: 4,
                background: isSelect ? '#1A1A1A' : 'transparent',
                transition: 'background 0.1s',
                borderRadius: 8,
            }}
        >
            <div
                className={classes.boxItem}
                style={{
                    backgroundColor: 'white',
                    width: `100%`,
                    borderRadius: 8,
                }}
                onClick={handleClick}
            >
                <img
                    style={{ width: '20%', objectFit: 'contain', marginTop: 'auto', marginBottom: 'auto' }}
                    src={imageUrl}
                    alt=""
                    className={classes.boxImg}
                />
                {isSelect && <SelectItemOverlay />}
            </div>
            <p
                className={classes.itemTitle}
                style={{
                    color: isSelect ? '#F2F2F2' : '#1A1A1A',
                }}
            >
                {label}
            </p>
        </div>
    );
}
